import { useState, useMemo } from 'react';
import Modal from '../Modal';
import { formatData } from '../../data/formatData';

export default function Download ({
	setModal,
	cropperRef,
	outputWidth,
	outputHeight,
	uploadedFilename,
	uploadedContentType,
	outputPreset
}) {
	const [outputFormat, setOutputFormat] = useState(uploadedContentType);

	function doSetFormat (e) {
		const format = e.target.dataset.format;
		setOutputFormat(format);
	}

	function doDownload () {

		const a = document.createElement('a');
		a.href = renderedImage;
		a.download = downloadFilename;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);

		setModal('share');
	}

	const downloadFilename = useMemo(function () {
		const basename = uploadedFilename.substring(0, uploadedFilename.lastIndexOf('.'));
		return `${basename}-${outputPreset.id}-${outputWidth}x${outputHeight}.${outputFormat}`;
	}, [uploadedFilename, outputFormat, outputPreset, outputWidth, outputHeight]);

	const renderedImage = useMemo(function () {
		const formatRecord = formatData.find(f => {
			return f.id === outputFormat;
		});

		return cropperRef.current.cropper.getCroppedCanvas({
			fillColor: '#ffffff',
			width: outputWidth,
			height: outputHeight
		}).toDataURL(formatRecord.contentType);
	}, [outputFormat, outputWidth, outputHeight]);

	// const formatRecord = useMemo(function () {
	// 	return formatData.find(f => {
	// 		return f.id === outputFormat;
	// 	});
	// });

	return (
		<Modal setModal={setModal}>
			<div className="mb-3 text-center">
				<div>
					<label>How do you want to download it?</label>
				</div>
				<div className="btn-group">
					{formatData.map(format => {
						return <div
							className={`btn btn-outline-secondary gap-0 flex-column ${format.id === outputFormat ? 'active' : ''}`}
							key={`modal-format-${format.id}`}
							data-format={format.id}
							onClick={doSetFormat}
						>
							<b className="fs-3">{format.label}</b>
							<div>{format.description}</div>
						</div>;
					})}
				</div>
			</div>
			<div className="text-center text-center px-4 pt-2">
				<img
					src={renderedImage}
					alt=""
					style={{
						maxHeight: '300px'
					}}
					className="img-fluid shadow"/>
				<div className="my-3 mx-5">
					<pre className="form-control text-start text-black-50 bg-secondary-subtle"
					>
						Filename: {downloadFilename}<br/>
						Size: {outputWidth}px&nbsp;×&nbsp;{outputHeight}px<br/>
						Format: {outputFormat}
					</pre>
				</div>
			</div>
			<div className="text-center mb-3">
				<button type="button"
				        className="btn btn-primary btn-lg"
				        onClick={doDownload}
				>Download it!
				</button>
			</div>
		</Modal>
	);
}